'use strict';

angular.module('bringgApp').config(function ($locationProvider) {
	$locationProvider.html5Mode = true;
});
